import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { JobService } from '../../../service/job.service';
import { JobDetailFootComponent } from './job-detail-foot/job-detail-foot.component';
import { JobEvaluateComponent } from './job-detail-foot/job-evaluate/job-evaluate.component';
import { JobDetailHeaderComponent } from './job-detail-header/job-detail-header.component';
import { Store } from '@ngxs/store';
import { AuthState } from '../../../store/authInfo/auth-state';
import { HistoryRepairRecordComponent } from './history-repair-record/history-repair-record.component';
import { KnowledgeManagerComponent } from '../../../knowledge/knowledge-manager/knowledge-manager.component';
import { HistoryReceiveRecordComponent } from './history-receive-record/history-receive-record.component';
import { ToolManagerComponent } from '../../../tool/tool-manager/tool-manager.component';
import { JobCostComponent } from './job-cost/job-cost.component';
import { CostService } from '../../../service/cost.service';
import { JobCostListComponent } from './job-cost-list/job-cost-list.component';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { JobVerifyComponent } from './job-detail-foot/job-verify/job-verify.component';
import { JobSignatureComponent } from './job-signature/job-signature.component';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { SpareListComponent } from '../../../facility/spareparts-management/spare-list/spare-list.component';
import { TakeSpareDetailComponent } from '../../../facility/take-spare/take-spare-detail/take-spare-detail.component';

@Component({
  selector: 'app-job-detail',
  templateUrl: './job-detail.component.html',
  styleUrls: ['./job-detail.component.less']
})
export class JobDetailComponent implements OnInit {
  @ViewChild('detailHeader', { static: true }) jobDetailHeaderComponent: JobDetailHeaderComponent;
  @ViewChild('detailFoot', { static: true }) jobDetailFootComponent: JobDetailFootComponent;
  @ViewChild('jobCost', { static: true }) jobCostComponent: JobCostComponent;
  @ViewChild('jobDetail') jobDetailElement!: ElementRef;
  @Input() currentJob: any;
  @Input() code: number;
  validateForm: FormGroup = null;
  listOfAllData = [];
  validated = false;
  authState = null;
  constructor(
    private modal: NzModalRef,
    private jobService: JobService,
    private message: NzMessageService,
    private modalService: NzModalService,
    private store: Store,
    private costService: CostService,
    private customValidatorService: CustomValidatorService) { }
  async ngOnInit() {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.currentJob = await this.jobService.getJob(this.currentJob.jno);
    this.updateListOfAllData(this.currentJob);
  }
  operaFunction(code) {
    // code 0 关闭 1 受理 2 派发 3 重派 4 转出 5：编辑 6：通过审核 7：未通过审核
    switch (code) {
      case 0: this.modal.destroy();
              break;
      case 1:
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);

        if (this.validated) {
          const job = this.jobDetailHeaderComponent.getJob();
          job.status = '1';
          job.dispatcherNo = this.authState.userInfo.userId;
          job.updateBy = this.authState.userInfo.userId;
          this.updateJob(job);
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 2:
        const item: any = this.jobDetailFootComponent.getCheckedItem();
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const job = this.jobDetailHeaderComponent.getJob();
          job.status = '2';
          job.repairerNo = item[0].userId;
          job.dispatcherNo = this.authState.userInfo.userId;
          job.updateBy = this.authState.userInfo.userId;
          // if ( job.dispatcherNo !== this.authState.userInfo.userId){
          //   this.message.warning('工单已有管理员处置，请勿操作！');
          //   break;
          // }
          this.updateJob(job);
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 3:
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const job = this.jobDetailHeaderComponent.getJob();
          job.status = '1';
          job.repairerNo = null;
          job.updateBy = this.authState.userInfo.userId;
          job.dispatcherNo = this.authState.userInfo.userId;
          job.reminderTimes = 0;
          // if ( job.dispatcherNo !== this.authState.userInfo.userId){
          //   this.message.warning('工单已有管理员处置，请勿操作！');
          //   break;
          // }
          this.updateJob(job);
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 4:
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const job = this.jobDetailHeaderComponent.getJob();
          job.status = '1';
          job.repairerNo = null;
          job.updateBy = this.authState.userInfo.userId;
          job.dispatcherNo = this.authState.userInfo.userId;
          // if ( job.dispatcherNo !== this.authState.userInfo.userId){
          //   this.message.warning('工单已有管理员处置，请勿操作！');
          //   break;
          // }
          this.updateJob(job);
          this.modal.destroy();
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 6: // 审核通过
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const modal = this.modalService.create({
            nzTitle: '工单审核',
            nzContent: JobVerifyComponent,
            nzStyle: { top: '20px' },
            nzWidth: 450,
            nzOnOk: (ev) => {
                const job = this.jobDetailHeaderComponent.getJob();
                job.status = '5';
                job.updateBy = this.authState.userInfo.userId;
                job.dispatcherNo = this.authState.userInfo.userId;
                job.dispatcherName = this.authState.userInfo.userName;
                if (!this.isEmpty(ev.verifyDesc)){
                  job.verifyDesc = ev.verifyDesc;
                }else{
                  job.verifyDesc = '';
                }
                this.updateJob(job);
                this.modal.destroy();
            },
            nzOnCancel: (ev) => {
            }
          });
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 7: // 未审核通过
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const modal = this.modalService.create({
            nzTitle: '工单审核',
            nzContent: JobVerifyComponent,
            nzStyle: { top: '20px' },
            nzWidth: 450,
            nzOnOk: (ev) => {
              if (this.isEmpty(ev.verifyDesc)) {
                this.modalService.warning({
                  nzTitle: '提交工单审核',
                  nzContent: '审核内容必填',
                  nzOkText: '确定',
                });
              }
              else {
                const job = this.jobDetailHeaderComponent.getJob();
                job.status = '3';
                job.updateBy = this.authState.userInfo.userId;
                job.dispatcherNo = this.authState.userInfo.userId;
                job.dispatcherName = this.authState.userInfo.userName;
                job.verifyDesc = ev.verifyDesc;
                this.updateJob(job);
                modal.destroy();
              }
            },
            nzOnCancel: (ev) => {
            }
          });
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      case 5:
        // 先判断表单中的数据是否都验证通过
        this.validateForm = this.jobDetailHeaderComponent.getValidateForm();
        // this.validated = this.jobDetailHeaderComponent.validateFormData()
        this.validated = this.validateFormData(code);
        if (this.validated) {
          const nJob = this.jobDetailHeaderComponent.getJob();
          nJob.updateBy = this.authState.userInfo.userId;
          // if ( nJob.dispatcherNo !== this.authState.userInfo.userId){
          //   this.message.warning('工单已有管理员处置，请勿操作！');
          //   break;
          // }
          this.updateJob(nJob);
        } else {
          this.message.warning('工单数据未验证通过');
        }
        break;
      default:
        break;
    }
  }
  linkFunction(codeNum) {
    switch (codeNum) {
      case 0:
        break;
      case 1: // 创建领料单
        if (this.currentJob.status === '3') {
          const modalTakeSpareDetail = this.modalService.create({
            nzTitle: '创建-领料单',
            nzContent: TakeSpareDetailComponent,
            nzStyle: { top: '20px' },
            nzWidth: 1000,
            nzFooter: null,
            nzMaskClosable: false,
            nzComponentParams: {
              takeSpareNo: null,
              missionNo: this.currentJob.jno,
              description: null,
              flag: 1,
            }
          });
        } else {
          this.message.create('warning', `当前状态下，不能够创建领料单`);
        }
        break;
      case 2: // 查看当前工单对应的所有领料单
        const modalReceive = this.modalService.create({
          nzTitle: '领料单列表',
          nzContent: HistoryReceiveRecordComponent,
          nzStyle: { top: '40px' },
          nzWidth: 1000,
          nzMaskClosable: false,
          nzFooter: null,
          nzComponentParams: {
            jobId: this.currentJob.jno,
          }
        });
        break;
      case 3: // 知识库
        const modalKnowledge = this.modalService.create({
          nzTitle: '知识库列表',
          nzContent: KnowledgeManagerComponent,
          nzStyle: { top: '40px' },
          nzWidth: 1000,
          nzMaskClosable: false,
          nzFooter: null,
          nzComponentParams: {
            code: 0, // code 0 知识库只能查看，不能创建 code 1 知识库可以查看 也可以被选中
          }
        });
        break;
      case 4: // 备件库
        const modalSpareList = this.modalService.create({
          nzTitle: '备件列表',
          nzContent: SpareListComponent,
          nzStyle: { top: '40px' },
          nzWidth: 800,
          nzMaskClosable: false,
          nzFooter: null,
          nzComponentParams: {
            code: 0, // code 0 备件只能查看，不能选择 code 1 备件可以查看 也可以被选中
          }
        });
        break;
      case 5: // 历史维修记录
        this.modalService.create({
          nzTitle: '历史维修记录',
          nzContent: HistoryRepairRecordComponent,
          nzStyle: { top: '20px' },
          nzWidth: 800,
          nzComponentParams: {
            equipmentId: this.currentJob.epNo,
          }
        });
        break;
      case 6: // 评价
        this.modalService.create({
          nzTitle: '工单评价',
          nzContent: JobEvaluateComponent,
          nzStyle: { top: '20px' },
          nzWidth: 450,
          nzComponentParams: {
            currentJob: this.currentJob,
            code: 1, // code 1 工单评价
          },
          nzOnOk: (ev) => {
            if (this.isEmpty(ev.adminStar) || this.isNaN(ev.adminStar)) {
              this.modalService.warning({
                nzTitle: '提交工单评价',
                nzContent: '请选择及时性星级评价',
                nzOkText: '确定',
              });
            }else if (this.isEmpty(ev.adminAttitudeStar) || this.isNaN(ev.adminAttitudeStar)) {
              this.modalService.warning({
                nzTitle: '提交工单评价',
                nzContent: '请选择服务态度星级评价',
                nzOkText: '确定',
              });
            } else if (this.isEmpty(ev.adminQualityStar) || this.isNaN(ev.adminQualityStar)) {
              this.modalService.warning({
                nzTitle: '提交工单评价',
                nzContent: '请选择维修质量星级评价',
                nzOkText: '确定',
              });
            } else {
              const job = this.jobDetailHeaderComponent.getJob();
              job.textEvaluationAdmin = ev.adminDesc;
              job.starEvaluationAdmin = ev.adminStar;
              job.starAttitudeEvaluationAdmin = ev.adminAttitudeStar;
              job.starQualityEvaluationAdmin = ev.adminQualityStar;
              this.updateJob(job);
            }
          },
          nzOnCancel: (ev) => {
          }
        });
        break;
      case 7: // 评价详情
        this.modalService.create({
          nzTitle: '工单评价',
          nzContent: JobEvaluateComponent,
          nzStyle: { top: '20px' },
          nzWidth: 450,
          nzComponentParams: {
            currentJob: this.currentJob,
            code: 0, // code 0 工单详情
          },
          nzOnOk: (ev) => {
          },
          nzOnCancel: (ev) => {
          }
        });
        break;
      case 8:
        const modalToolList = this.modalService.create({
          nzTitle: '工具列表',
          nzContent: ToolManagerComponent,
          nzStyle: { top: '40px' },
          nzWidth: 800,
          nzMaskClosable: false,
          nzFooter: null,
          nzComponentParams: {
            code: 0, // code 0 工具只能查看，不能选择 code 1 工具可以查看 也可以被选中
          }
        });
        break;
      case 9:
        const modalCost = this.modalService.create({
          nzTitle: '费用填报',
          nzContent: JobCostComponent,
          nzStyle: { top: '40px' },
          nzWidth: 650,
          nzOnOk: async (ev) => {
            // const instance = modalCost.getContentComponent();
            // const form = instance.getCostForm();
            const form = ev.getCostForm();
            // tslint:disable-next-line:forin
            if (!ev.validateCostFormData(form)) {
              return false;
            } else {
              const cost = {
                money: form.value.money,
                costDesc: this.isEmpty(form.value.costDesc) ? '' : form.value.costDesc,
                costType: form.value.costType,
                relatedProvideId: this.isEmpty(form.value.relatedProvideId) ? null : form.value.relatedProvideId,
                relatedJobId: this.currentJob.jno,
                createBy: this.authState.userInfo.userId
              };
              const result: any = await this.costService.addCost(cost);
              if (result.code === 200) {
                this.message.success('费用添加成功');
                this.currentJob = JSON.parse(JSON.stringify(this.currentJob));
                // return result.data;
              } else {
                this.message.error('费用添加失败');
                return false;
              }
            }
          },
          nzOnCancel: (ev) => {
          }
        });
        break;
      case 10: // 查看费用
        const modalCostList = this.modalService.create({
          nzTitle: '费用查看',
          nzContent: JobCostListComponent,
          nzStyle: { top: '40px' },
          nzWidth: 700,
          nzComponentParams: {
            jobId: this.currentJob.jno,
          },
          nzOnOk: async (ev) => {
          },
          nzOnCancel: (ev) => {
          }
        });
        modalCostList.afterClose.subscribe((e) => {
          if (e === 0) {// 删除完所有费用后，需要刷新一下工单界面
            this.currentJob = JSON.parse(JSON.stringify(this.currentJob));
          }
        });
        break;
      case 11:
        const modalSignatureList = this.modalService.create({
          nzTitle: '签名查看',
          nzContent: JobSignatureComponent,
          nzStyle: { top: '40px' },
          nzWidth: 700,
          nzComponentParams: {
            jobId: this.currentJob.jno,
          },
          nzOnOk: async (ev) => {
          },
          nzOnCancel: (ev) => {
          }
        });
        break;
      case 12:  // 保存PDF
        this.generatePDF();
        break;
    }
  }
  // 更新工单
  updateJob(job: any) {
    job.updateBy = this.authState.userInfo.userId;
    this.jobService.updateJob(job)
      .subscribe(async (res) => {
        if (res.code === 200) {
          this.currentJob = await this.jobService.getJob(this.currentJob.jno);
          // 获取维修员列表
          this.updateListOfAllData(this.currentJob);
          // this.currentJob = job;
          this.message.info('工单操作成功');
        } else {
          this.message.error('工单操作失败');
        }
      }, err => {
        this.message.error('工单操作失败: ' + err.msg);
      });
  }
  typeChanged(key) {
    if (key !== this.currentJob.jtNo) {
      this.jobDetailFootComponent.setTransfer(true);
    } else {
      this.jobDetailFootComponent.setTransfer(false);
    }
  }
  thirdServiceChanged(key){
    this.jobDetailFootComponent.setThirdService(key);
  }
  async updateListOfAllData(job: any) {
    // tslint:disable-next-line:radix
    switch (parseInt(job.status)) {
      case 1:
        const ls1 = await this.jobService.getUsersBySkillId(this.formatDate(new Date(), 'yyyy/MM/dd'), job.jtNo);
        // const ls1 = await this.jobService.getDutysByDateAndJobType(new Date('2020-12-11 09:31:17.000').toLocaleDateString(), job.jtNo);
        if (ls1 == null) {
          this.listOfAllData = [];
        } else {
          this.listOfAllData = ls1;
        }
        break;
      case 2:
      case 3:
      case 4:
      case 5:
        const ls2 = await this.jobService.getUsersByDateAndUserId(this.formatDate(new Date(), 'yyyy/MM/dd'), job.repairerNo);
        // tslint:disable-next-line:max-line-length
        // const ls2 = await this.jobService.getDutyByDateAndUserId(new Date('2020-12-11 09:31:17.000').toLocaleDateString(),job.repairerNo);
        if (ls2 == null) {
          this.listOfAllData = [];
        } else {
          this.listOfAllData = ls2;
          this.currentJob.repairerName = ls2[0].userName;
        }
        break;
      default:
        break;
    }
  }
  public validateFormData(code) {
    // 如果工单状态为未受理状态，或者为转出操作，修改状态 不需要验证预计工时和预计完成时间
    // 若为修改状态，并且当前工单为未处理状态，不需要验证预计工时和预计完成时间
    // if (this.currentJob.status === '0' || code === 4) {
    if (code === 4 || (code === 5 && this.currentJob.status === '1')) {
      this.validateForm.get('hourEstimation').clearValidators();
      this.validateForm.get('hourEstimation').markAsPristine();
      this.validateForm.get('estimatedCompletedTime').clearValidators();
      this.validateForm.get('estimatedCompletedTime').markAsPristine();
    } else {
      this.validateForm.get('hourEstimation').setValidators([Validators.required, this.customValidatorService.oneDecimalValidator]);
      this.validateForm.get('hourEstimation').markAsDirty();
      this.validateForm.get('estimatedCompletedTime').setValidators(Validators.required);
      this.validateForm.get('estimatedCompletedTime').markAsDirty();
    }
    // if ( this.validateForm.value.isEquipment){
    //   this.validateForm.get('epNo').setValidators(Validators.required);
    // }else{
    //   this.validateForm.get('epNo').clearValidators();
    // }
    // tslint:disable-next-line:forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    return this.validateForm.valid;
  }
  public formatDate( date: Date, format: string){
    format = format.replace('yyyy', date.getFullYear() + '');
    format = format.replace('MM', date.getMonth() + 1 + '');
    format = format.replace('dd', date.getDate() + '');
    return format;
  }
  public generatePDF(): void {
    html2canvas(this.jobDetailElement.nativeElement, { scale: 3 }).then((canvas) => {
      // const imageGeneratedFromTemplate = canvas.toDataURL('image/png');
      // const fileWidth = 200;
      // const generatedImageHeight = (canvas.height * fileWidth) / canvas.width;
      // const PDF = new jsPDF('p', 'pt', 'a4');
      // PDF.addImage(imageGeneratedFromTemplate, 'PNG', 5, 5, fileWidth, generatedImageHeight);
      // PDF.html(this.jobDetailElement.nativeElement.innerHTML);
      // PDF.save('angular-invoice-pdf-demo.pdf');

      const width = this.jobDetailElement.nativeElement.offsetWidth / 2;
      const height = this.jobDetailElement.nativeElement.offsetHeight / 2;
      const context = canvas.getContext('2d');
      context.imageSmoothingEnabled = false;
      const pageData = canvas.toDataURL('image/jpeg', 1.0);
      const img = new Image();
      img.src = pageData;
      img.onload = () => {
          // 获取dom高度、宽度
          img.width = img.width / 2;
          img.height = img.height / 2;
          context.imageSmoothingEnabled = false;
          img.style.transform = 'scale(3)';
          const pdf = new jsPDF('p', 'mm', [
            width * 0.5 + 20,
            height * 0.5 + 20
        ]);
          pdf.addImage(
              pageData,
              'jpeg',
              10,
              10,
              width * 0.5,
              height * 0.5
          );
          pdf.save('工单' + this.currentJob.jno + '_' + new Date().getTime() + '.pdf');
      };

      // 代码可以分成多页打印，但是页与页之间需要在处理截断处，
       // 一页pdf显示html页面生成的canvas高度;
      //  const contentWidth = canvas.width;
      //  const contentHeight = canvas.height;
      //  const pageHeight = contentWidth / 560 * 842;
      //  // 未生成pdf的html页面高度
      //  let leftHeight = contentHeight;
      //  // pdf页面偏移
      //  let position = 0;
      //  // 纸的尺寸[560,842]，html页面生成的canvas在pdf中图片的宽高
      //  const imgWidth = 560;
      //  const imgHeight = 560 / contentWidth * contentHeight;
      //  const pageData = canvas.toDataURL('image/jpeg');
      //  const pdf = new jsPDF('p', 'pt', 'a4');
      //  // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(842)
      //  // 当内容未超过pdf一页显示的范围，无需分页
      //  if (leftHeight < pageHeight) {
      //      pdf.addImage(pageData, 'JPEG', 20, 20, imgWidth, imgHeight);
      //  } else {
      //      while (leftHeight > 0) {
      //          pdf.addImage(pageData, 'JPEG', 20, position + 20 , imgWidth, imgHeight);
      //          leftHeight -= pageHeight;
      //          position -= 842;
      //          // 避免添加空白页
      //          if (leftHeight > 0) {
      //              pdf.addPage();
      //          }
      //      }
      //  }
      //   // 导出pdf文件命名
      //  pdf.save('工单' + this.currentJob.jno + '_' + new Date().getTime() + '.pdf');
    });
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
  public isNaN(obj: any) {
    // tslint:disable-next-line:radix
    return isNaN(parseInt(obj));
  }
}
